import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBQoowuGCYxCYr7wj_-6cIJzHaZVxsNvBA",
  authDomain: "mind-reset-33396.firebaseapp.com",
  databaseURL: "https://mind-reset-33396.firebaseio.com",
  projectId: "mind-reset-33396",
  storageBucket: "mind-reset-33396.appspot.com",
  messagingSenderId: "1065218710379",
  appId: "1:1065218710379:web:a3c29f121a55aa35838a2e"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export default function FirebaseApp() {
  return new Promise((resolve, reject) => {
    if (!auth.currentUser) {
      reject(new Error("User is not authenticated"));
      return;
    }

    resolve(getDatabase(app));
  });
}

export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: "select_account",
});
